var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.emoji)+" "+_vm._s(_vm.title))]),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('i',{staticClass:"fas fa-external-link-alt fa-lg"})])
}]

export { render, staticRenderFns }